import React from 'react'
import "./ListConnectWhatsAppFeature.css";

const ListConnectWhatsAppFeature = (props) => {
  return (
    <li class='listConnectWhatsAppFeature'>
        <img className='listConnectWhatsAppFeature-img' src={props.img} alt="listConnectWhatsAppFeature-img" />
        <div>
            <h6 className='listConnectWhatsAppFeature-heading'>{props.heading}</h6>
            <p className='listConnectWhatsAppFeature-subHeading'>{props.subHeading}</p>
        </div>
    </li>
  )
}

export default ListConnectWhatsAppFeature